import React, { useState, useEffect, useRef } from 'react'
import i18n from 'i18n/index.js'
import Product from "components/products/Product";
import {from_price} from "components/utils/Money.jsx";
import { fetchWithLocale } from "components/utils/Api.jsx";
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId: 'GTM-W6W9H6NJ'
}
TagManager.initialize(tagManagerArgs)

function Products(props) {
  const pageRef = useRef(1); 
  const newPage = useRef(1); 
  const [products, setProducts] = useState([]);
  const [optional_products, setOptionalProducts] = useState([]);
  const [optinal_results_text, setOptinalResultsText] = useState("");
  const [optinal_results, setOptinalResults] = useState(false);
  
  const [activities, setActivities] = useState([]);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isPageloading, setIsPageloading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  
  const [activityValue, setActivityValue] = useState("");
  const [regionValue, setRegionValue] = useState("");
  const [timeValue, setTimeValue] = useState("");
  const [dateValue, setDateValue] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [dateValueForSelect, setDateValueForSelect] = useState("");
  const [isSearch, setIsSearch] = useState(false)
  const [activityObject, setActivityObject] = useState("");
  const [regionObject, setRegionObject] = useState("");
  
  const [titleSearch, setTitleSearch] = useState("");
  const [descriptionCategory, setDescriptionCategory] = useState(false);

  const [selectedDate, setSelectedDate] = useState(null);
  const handleDateChange = (date) => {
    setSelectedDate(date);
    setDateValue(date);
    setDateValueForSelect("current_date");
  };

  const [initialTitle, setInitialTitle] = useState(i18n.t("products_search.all_adventures"));
  const [loadingTitle, setLoadingTitle] = useState(true);
  
  let guide_image = "https://viewnia-static.s3.us-east-2.amazonaws.com/especialista.png";

  // Mapeo de valores de tiempo
  const timeOptions = [
    { value: "half_day", label: i18n.t("excursions.half_day") },
    { value: "full_day", label: i18n.t("excursions.full_day") },
    { value: "multiple_days", label: i18n.t("excursions.multiple_days") }
  ];

  // Actualiza el parámetro 'page' en la URL del navegador sin recargar la página
  const updateUrlPage = (pageNumber, customParams = null) => {
    try {
      const url = new URL(window.location.href);
      if (customParams) {
        if (customParams.activity) url.searchParams.set('activity', customParams.activity);
        else if (customParams.activity === "") url.searchParams.delete('activity');

        if (customParams.region) url.searchParams.set('region', customParams.region);
        else if (customParams.region === "") url.searchParams.delete('region');

        if (customParams.time) url.searchParams.set('time', customParams.time);
        else if (customParams.time === "") url.searchParams.delete('time');

        if (customParams.q) url.searchParams.set('q', customParams.q);
        else if (customParams.q === "") url.searchParams.delete('q');
      }
      if (pageNumber > 1) {
        url.searchParams.set('page', pageNumber);
      } else {
        url.searchParams.delete('page');
      }
      window.history.pushState({}, '', url.toString());
    } catch (e) {
      console.error("Error al actualizar la URL:", e);
    }
  };

  // Función para manejar búsquedas desde el header
  const handleSearchFromHeader = (activity, region, time) => {
    setActivityValue(activity || "");
    setRegionValue(region || "");
    setTimeValue(time || "");
    setIsSearch(true);
    search(activity, region, time);
  };

  // Toda la lógica original preservada con soporte para lectura de página inicial desde la URL
  useEffect(() => {
    console.log("Component mounted, loading initial data...");
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let activity = ""
    let region = ""
    let time = ""
    let date = ""
    let query = ""
    let initialPage = 1;
    
    if (urlParams.has('page')) {
      const parsedPage = parseInt(urlParams.get('page'), 10);
      if (!isNaN(parsedPage) && parsedPage > 0) {
        initialPage = parsedPage;
      }
    }
    newPage.current = initialPage;
    pageRef.current = initialPage;
    
    if (urlParams.has('activity')){
      activity = (urlParams.get('activity'))
      setActivityValue(urlParams.get('activity'))
    }
    if(props.activity){
      activity = props.activity
      setActivityValue(props.activity)
    }
    if (urlParams.has('region')){
      region = (urlParams.get('region'))
      setRegionValue(urlParams.get('region'))
    }
    if (urlParams.has('time')){
      time = (urlParams.get('time'))
      setTimeValue(urlParams.get('time'))
    }
    if (urlParams.has('date')){
      date = (new Date(Date.parse(urlParams.get('date'))))
      setDateValue(date)
      setSelectedDate(date);
      setDateValueForSelect("current_date")
    }
    if (urlParams.has('q')){
      query = urlParams.get('q')
      setQueryValue(query)
      setIsSearch(true)
    }

    setTimeout(() => {
      if (urlParams.has('q')) {
        setInitialTitle(urlParams.get('q'));
      } else if ((urlParams.has('activity') && isNaN(urlParams.get('activity'))) || 
          props.activity || 
          (urlParams.has('region') && isNaN(urlParams.get('region'))) || 
          urlParams.has('time') || 
          urlParams.has('date')) {
        let titleParts = [];
        if (urlParams.has('activity') && isNaN(urlParams.get('activity'))) {
          titleParts.push(props.activity || urlParams.get('activity'));
        }
        if (urlParams.has('region') && isNaN(urlParams.get('region'))) {
          titleParts.push(urlParams.get('region'));
        }
        if (urlParams.has('time')) {
          titleParts.push(i18n.t("excursions." + urlParams.get('time')));
        }
        if (urlParams.has('date')) {
          titleParts.push(new Date(Date.parse(urlParams.get('date'))).toLocaleDateString());
        }
        if (titleParts.length > 0) {
          setInitialTitle(titleParts.join(" " + i18n.t("products_search.in") + " "));
        }
      }
      setLoadingTitle(false);
    }, 1000);

    get_products(activity, region, time, date, false, query, initialPage);
  }, []);

  useEffect(() => {
    if(activityValue){
      setActivityObject(activities.find(activity => activity.id ==  activityValue))
    }
    if(regionValue){
      setRegionObject(regions.find(region => region.id ==  regionValue))
    }
  }, [activityValue, regionValue]);

  function search(activityVal = activityValue, regionVal = regionValue, timeVal = timeValue, queryVal = queryValue){
    console.log("Search function called");
    setIsSearch(true)
    newPage.current = 1
    pageRef.current = 1
    updateUrlPage(1, { activity: activityVal, region: regionVal, time: timeVal, q: queryVal })
    get_products(activityVal, regionVal, timeVal, dateValue, false, queryVal, 1);
  }

  function handleLoadMore() {
    if (isPageloading || !hasMore) return;
    const nextPage = newPage.current + 1;
    updateUrlPage(nextPage);
    get_products(activityValue, regionValue, timeValue, dateValue, true, queryValue, nextPage);
  }

  useEffect(() => {
    if(isSearch){
      get_products(activityValue, regionValue, timeValue, dateValue, false, queryValue, 1);
    }
  }, [isSearch]);

  function get_products(activityValue_t = null, regionValue_t = null, timeValue_t= null, dateValue_t= null, isNewPage = false, queryValue_t = null, targetPage = null){
    console.log("Getting products...", { activityValue_t, regionValue_t, timeValue_t, dateValue_t, queryValue_t, isNewPage, targetPage });
    (!isNewPage && setLoading(true) || setIsPageloading(true))
    const nextPage = targetPage !== null ? targetPage : (isNewPage ? newPage.current + 1 : 1)
    const queryParam = queryValue_t ? `&q=${encodeURIComponent(queryValue_t)}` : '';

    return fetchWithLocale(`/get_products.json?activity=${activityValue_t}&region=${regionValue_t}&time=${timeValue_t}&date=${dateValue_t}&page=${nextPage}${queryParam}`)
      .then(response => response.json())
      .then(json => {
        console.log("Products received:", json);
        const batch = json.excursions || [];
        let uniqueProducts;
        setProducts(prev => {
          const updatedProducts = isNewPage ? [...prev, ...batch] : batch;
          uniqueProducts = Array.from(new Map(updatedProducts.map(p => [p.id, p])).values());
          return uniqueProducts;
        });
        createDataLayer(uniqueProducts);
        setActivities(json.activities)
        setRegions(json.regions)
        setLoading(false)
        setIsPageloading(false)
        newPage.current = nextPage
        pageRef.current = nextPage
        setHasMore(json.has_more)
        setTotalCount(typeof json.total_count === "number" ? json.total_count : uniqueProducts.length)
        let activitiesObj = {}
        let regionsObj = {}
        
        if(activityValue_t){
          activitiesObj = (json.activities.find(activity => activity.id ==  activityValue_t))
        }
        if(regionValue_t){
          regionsObj = (json.regions.find(region => region.id ==  regionValue_t))
        }

        if(uniqueProducts.length > 0){
          setDescriptionCategory((activitiesObj && activitiesObj.description) ? activitiesObj.description : i18n.t("products_search.subtext"))
        }else{
          if(regionsObj.name  && activitiesObj.name ){
            setDescriptionCategory((activitiesObj && activitiesObj.description) ? activitiesObj.description : i18n.t("products_search.subtext"))
          }else if(activitiesObj.name ){
            setDescriptionCategory((activitiesObj && activitiesObj.description) ? activitiesObj.description : i18n.t("products_search.subtext"))
          }
        }
        setTitleSearch(queryValue_t
          ? queryValue_t
          : [(activitiesObj ? activitiesObj.name : ""), (regionsObj ? regionsObj.name : ""), (timeValue_t ? i18n.t("excursions." + timeValue_t) : ""), (dateValue_t ? dateValue_t.toLocaleDateString() : "")].filter(Boolean).join(" " + i18n.t("products_search.in") + " "));

        if(json.no_results_found){     
          if(json.optinal_results_text == "activity"){
            setOptinalResultsText((activityObject ? activityObject.name : ""))
          }
          else if(json.optinal_results_text == "region"){
            setOptinalResultsText((regionObject ? regionObject.name : ""))
          }
          else if(json.optinal_results_text == "time"){
            setOptinalResultsText((timeValue ? i18n.t("excursions." + timeValue) : ""))
          }else{
            setOptinalResultsText("")
          }
          setOptinalResults(json.no_results_found)
          setOptionalProducts(json.optinal_results)
        }
      })
      .catch(error => {
        console.error("Error fetching products:", error);
        setLoading(false);
        setIsPageloading(false);
      });
  }

  function createDataLayer(excursions){
    window.dataLayer.push({ ecommerce: null }); 
    var new_products = []; 
    excursions && excursions.map((product) => {
      new_products.push(
        {
          'item_id': product.id,
          'item_name': product.title,
          'price': from_price(product),
          'item_brand': (product.agency ? product.agency?.name : "Outdoor Index"),
          'item_category': (product.zone && product.zone.name || ""),
          'item_variant': 'Excursion',
          'affiliation': 'Outdoor index',
          'quantity': '1'
        }
      )
    })
    window.dataLayer.push({
      'event': "view_item_list",
      'ecommerce': {
        'item_list_id': "products_list",
        'item_list_name': "Products List",
        'items': new_products
       }
    });
  }

  console.log("Rendering component, loading:", loading, "products:", products.length);

  const showHomeHero = Boolean(props.home_products && !isSearch);
  const heroTitle = titleSearch || (showHomeHero && props.home_title ? props.home_title : null) || initialTitle;
  const heroSubtext =
    showHomeHero && props.home_subtitle && String(props.home_subtitle).trim()
      ? props.home_subtitle
      : (descriptionCategory || i18n.t("products_search.subtext"));

  return (
    <section className="home-section">
        <section className="head-text">
          {loadingTitle || loading ? (
            <>
              <div
                className="skeleton-title oi-skeleton oi-skeleton--wave oi-skeleton--text"
                style={{
                  width: "40%",
                  height: 60,
                  fontSize: "2.5rem",
                  lineHeight: "1.2",
                  transform: "none",
                  margin: "0 auto",
                  marginBottom: "1.5rem",
                  textAlign: "center",
                }}
                aria-hidden
              />
              <div
                className="skeleton-description oi-skeleton oi-skeleton--wave oi-skeleton--text"
                style={{
                  width: "50%",
                  height: 42,
                  fontSize: "1.1rem",
                  lineHeight: "1.5",
                  transform: "none",
                  margin: "0 auto",
                  marginBottom: "3em",
                  textAlign: "center",
                }}
                aria-hidden
              />
            </>
          ) : (
            <>
              <div className="head-text-info">
                <h1 className="head-text-title">
                  <strong>{heroTitle}</strong>
                  <div className="head-text-subtitle"><p>{heroSubtext}</p></div>
                </h1>
              </div>

              <div className="chat-widget">
                <div className="chat-avatar">
                  <img src={guide_image} alt="Especialista" />
                </div>
                <div className="chat-content">
                  <p className="chat-question">{i18n.t('chat.need_help')}</p>
                  <a
                    href="https://api.whatsapp.com/send?phone=56981785011"
                    className="chat-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="chat-answer">
                      {i18n.t('chat.talk_to_local_guide')}
                    </p>
                  </a>
                </div>
              </div>
            </>
          )}
        </section>

        <section className="products-section">
          {(props.home_products && !isSearch) ? (
            <div className="products-grid">
                {props.home_products.map((product) => {
                  const labelId = `products-label-${product.id}`;
                  return (
                    <div className="products-grid__item" key={labelId}>
                      <Product
                        product={product}
                        image_format={"large"}
                      />
                    </div>
                  );
                })}
              </div>
          ) : (
            <>
              {loading ? (
                <div className="products-grid">
                  {Array.from(new Array(8)).map((item, index) => (
                    <div key={"skeleton" + index} className='products-grid__item posts'>
                      <div
                        className="lazyload oi-skeleton oi-skeleton--wave oi-skeleton--rounded oi-w-full"
                        style={{ height: 394 }}
                        aria-hidden
                      />
                      <div
                        className="lazyload info-slide product-skeleton-line oi-skeleton oi-skeleton--wave oi-skeleton--text oi-w-full"
                        style={{ height: 10 }}
                        aria-hidden
                      />
                      <div
                        className="lazyload product-skeleton-line oi-skeleton oi-skeleton--wave oi-skeleton--text oi-w-full"
                        style={{ height: 10 }}
                        aria-hidden
                      />
                      <div
                        className="lazyload product-skeleton-line oi-skeleton oi-skeleton--wave oi-skeleton--text oi-w-full"
                        style={{ height: 10 }}
                        aria-hidden
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="products-grid">
                  {products && products.map((product) => {
                      let labelId = `products-label-${product.id}`;
                      return (
                        <div className="products-grid__item" key={labelId}>
                          <Product
                            product={product}
                            image_format={"large"}
                          />
                        </div>
                      );
                  })}
                </div>
              )}

              {!loading && products.length > 0 && (totalCount > 0 || hasMore) && (
                <div className="products-load-more">
                  <div
                    className="products-load-more__track"
                    role="progressbar"
                    aria-valuemin={0}
                    aria-valuemax={100}
                    aria-valuenow={totalCount ? Math.round((products.length / totalCount) * 100) : 0}
                  >
                    <div
                      className="products-load-more__fill"
                      style={{
                        width: totalCount ? `${Math.min(100, (products.length / totalCount) * 100)}%` : "0%",
                      }}
                    />
                  </div>
                  <p className="products-load-more__status">
                    {i18n.t("products_search.showing_count", {
                      loaded: products.length,
                      total: totalCount || products.length,
                    })}
                  </p>
                  {hasMore && (
                    <a
                      href={`/products?${new URLSearchParams({
                        ...(activityValue ? { activity: activityValue } : {}),
                        ...(regionValue ? { region: regionValue } : {}),
                        ...(timeValue ? { time: timeValue } : {}),
                        ...(dateValue ? { date: dateValue } : {}),
                        ...(queryValue ? { q: queryValue } : {}),
                        page: (newPage.current || 1) + 1,
                      }).toString()}`}
                      className="products-load-more__button"
                      aria-busy={isPageloading}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLoadMore();
                      }}
                    >
                      {isPageloading ? (
                        <span className="products-load-more__loader" aria-hidden="true">
                          <span className="request-submit-dot" />
                          <span className="request-submit-dot" />
                          <span className="request-submit-dot" />
                        </span>
                      ) : (
                        i18n.t("products_search.load_more")
                      )}
                    </a>
                  )}
                </div>
              )}
            </>
          )}
        </section>

        {/* Optional products section */}
        {!loading && optional_products.length > 0 &&
          <section className="products-section">
            <div className="products-optional-heading">
                  <h2>
                    {optinal_results_text ? 
                      <>{optinal_results_text} ({optional_products.length})</> :
                      <>{i18n.t("products_search.all_adventures")} ({optional_products.length})</>
                    }
                  </h2>
            </div>
            <div className="products-grid">
              {optional_products && optional_products.map((product) => {
                  let labelId = `products-label-${product.id}`;
                  return (
                    <div className="products-grid__item" key={labelId}>
                      <Product
                        product={product}
                        image_format={"large"}
                      />
                    </div>
                  );
              })}
            </div>
          </section>
        } 
      </section>
  );
}

// Exponer la función handleSearchFromHeader para que el header pueda usarla
Products.handleSearchFromHeader = function(activity, region, time) {
  // Esta función será llamada desde el header
  console.log("Search triggered from header:", { activity, region, time });
};

export default Products;